<template>
  <div>
    <div class="pushu_nav">
      <div class="columnBoxInnner">
        <div class="columnBoxInnnerList">
          <div class="bookTitle">
            在线家谱
          </div>
          <span v-for="(item,index) in bookType" :key="index" :class="currentPushu==index?'activenames':'names'" @click="gopushu(item,index)"><span class="span_name">{{ item.DICTIONARY_NAME }}</span><span v-if="index!=bookType.length-1" style="margin: 0 8px;">/</span></span>
          <a class="bookTitle gomaker" :href="getTokenUrl" target="_blank" @click="changeurl">
            <svg-icon icon-class="addmaker" />
            立即创建我的家谱
          </a>
        </div>
      </div>
    </div>
    <div v-if="bookData.length>0" class="showlist">
      <a v-for="(item,index) in bookData" :key="index" class="lilist" :href="'/sourceView?sourceId='+item.SHOW_RES_ID+'&type='+item.SHOW_TYPE" target="_blank">
        <div class="imgBox">
          <img :src="item.COVER" alt="">
        </div>
        <div class="tipBox">
          <img :src="topmsgPng" alt="">
          <span>{{ item.PRIVACY_RULE|changeType }}</span>
        </div>
        <div class="hovermsg">
          <p>{{ item.BOOK_TITLE }}</p>
          <span class="Btype">{{ item.BOOK_TYPE|changeBookType }}</span>
          <div class="hovermsg_div">
            <img :src="item.USER_PHOTO" alt="">
            <span>{{ item.USER_NAME }}</span>
          </div>
          <div class="showTime">
            {{ item.CREATE_DATE }}
          </div>
          <div class="hovermsg_btn">
            <span><svg-icon icon-class="chakan" /></span>
            <a :href="'/sourceView?sourceId='+item.SHOW_RES_ID+'&type='+item.SHOW_TYPE" target="_blank">查看详情</a>
          </div>
        </div>
      </a>
    </div>
    <div v-else style="text-align: center;font-size: 20px;color: #a19d9e;font-weight: 600;background-color: #ffffff;height: 150px;line-height: 150px;">
      暂无数据
    </div>
    <div class="addMore" @click="addMore">
      <a class="addMore_span" href="/bookList">查看更多>></a>
      <!--<span v-show="loadAll">已经到底了</span>-->
    </div>
  </div>
</template>
<script>
// ///首页列表模板上中下形式
import { getClassz, getDataBookList } from '@/api/api.js'
import { addLoginState } from '@/api/login.js'
export default {
  filters: {
    changeType: val => {
      if (val == 1) {
        return '完全公开'
      }
      if (val == 2) {
        return '完全保密'
      }
      if (val == 3) {
        return '付费查阅'
      }
      if (val == 4) {
        return '密码查阅'
      }
    },
    changeBookType: val => {
      if (val == 1) {
        return '智能家谱'
      }
      if (val == 2) {
        return '电子家谱'
      }
    }
  },
  data() {
    return {
      getTokenUrl: '',
      currerntPage: 1,
      currentType: '',
      loadAll: false,
      bookData: [],
      bookType: [{ DICTIONARY_ID: '', DICTIONARY_NAME: '最新推荐' }],
      pushu: require('@/static/pushu.png'),
      currentPushu: 0,
      noIMG: require('@/static/home_noimg.png'),
      topmsgPng: require('@/static/tipmsg.png')
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    this.changeurl()
    this.initType()
  },
  methods: {
    // /查询字典
    initType() {
      getClassz({ classCode: 'bookType' }).then(res => {
        this.bookType = this.bookType.concat(res.data)
        // console.log(res.data)
      })
    },
    initData() {
      getDataBookList({ page: 1, limit: 10 }).then(res => {
        // console.log(res.data)
        this.bookData = res.data.listMapData
        if (res.data.count <= 10) {
          this.loadAll = true
        }
      })
    },
    gopushu(names, index) {
      this.loadAll = false
      this.currerntPage = 1
      this.currentType = names.DICTIONARY_ID
      getDataBookList({ page: 1, limit: 10, type: names.DICTIONARY_ID }).then(res => {
        this.bookData = res.data.listMapData
        if (res.data.count <= 10) {
          this.loadAll = true
        }
      })
      this.currentPushu = index
    },
    addMore() {
      this.$router.push({ path: '/bookList' })
      // this.currerntPage++
      // getDataBookList({ page: this.currerntPage, limit: 4, type: this.currentType }).then(res => {
      //   this.bookData = this.bookData.concat(res.data.listMapData)
      //   if (res.data.page <= this.currerntPage) {
      //     this.loadAll = true
      //   }
      // })
    },
    goBook() {
      this.$router.push({ path: '/bookList' })
    },
    goDetail(sourceId, type) {
      const { href } = this.$router.resolve({
        url: '/sourceView',
        name: 'sourceView',
        query: {
          sourceId,
          type
        }
      })
      window.open(href, '_blank')
    },
    changeurl(url) {
      url = 'http://maker.pengzushijia.com/ssoLogin/ssoLogin?token='
      // url = 'http://maker.myfamilybook.cn/ssoLogin/ssoLogin?token='
      if (this.getLoca('userid')) {
        addLoginState({ unionid: this.getLoca('unionid') }).then(res => {
          if (res.data.errcode === '0') {
            var nurl = url + res.data.token
            this.getTokenUrl = nurl
          }
          if (res.data.errcode == '1') {
            this.$alert('您的登录信息已经过期，请重新登录', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.$router.push('/login')
              }
            })
          }
        })
      } else {
        this.getTokenUrl = 'http://maker.pengzushijia.com'
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .firstcolumn_tip{
      margin-top: 20px;
      height: 68px;
      text-align: center;
      line-height: 68px;
      background-color: #fff;
      font-size: 24px;
      color: #353535;
        img{
            width:auto;
            height: 29px;
            margin-top: 20px;
        }
    }
    .pushu_nav{
      height: 60px;
      line-height: 60px;
      background-color: #fff;
      text-align: left;
      margin-bottom: 20px;
      margin-top: 20px;
        span{
            font-size: 15px;
            color: #333333;
        }
      .bookTitle{
        display: inline-block;
        height: 20px;
        line-height: 20px;
        border-left: 2px solid #ed4040;
        padding-left: 10px;
        font-size: 18px;
        margin-left: 20px;
        font-weight: 600;
        margin-right: 20px;
      }
      .gomaker{
        font-size: 14px;
        float: right;
        color: #fff;
        background-color: #7E6B5A;
        border-radius: 5px;
        border: none;
        margin-top: 15px;
        padding: 8px 10px;
        svg{
          font-size: 18px;
        }
        &:hover{
          background-color:rgba(227,0,58,.8);
        }
      }
        .names{
          .span_name{
            cursor: pointer;
            color: #333333;
            font-weight: 600;
            font-size: 16px;
          }
        }
        .activenames{
          .span_name{
            cursor: pointer;
            color: #ed4040;
            font-weight: 600;
            font-size: 16px;
          }
        }
    }
    .showlist{
        width: 100%;
        /*overflow: hidden;*/
        font-size: 0;
        .lilist{
          margin-bottom: 20px;
          background-color: #fff;
            position: relative;
            /*margin-top: 43px;*/
            display: inline-block;
            width: 219px;
            overflow: hidden;
            margin-right: 26px;
           box-shadow: 2px 2px 2px 2px hsla(0,0%,72%,.5);
          .imgBox{
            display: inline-block;
            width: 219px;
            height: 282px;
            text-align: center;
            background-color: #fff;
            padding: 10px 0;
            img{
              width: 199px;
              height: 282px;
              cursor: pointer;
            }
          }

            p{
                color: #333333;
                margin-top: 5px;
                font-size: 15px;
                height: 40px;
                overflow: hidden;
            }
            .tip{
                position: absolute;
                top: 7px;
                left: 9px;
                display: inline-block;
                width: 60px;
                background-color:rgba(0,0,0,.3);
                color: #ffffff;
                height: 20px;
                line-height: 20px;
                font-size: 12px;
                text-align: center;
                border-radius: 2px;
                cursor: pointer;
                &:hover{
                    color: #ed4040;
                }
            }
        }
       .lilist:nth-child(5n){
        margin-right: 0;
      }
    }
    .addMore{
      text-align: center;
      height: 45px;
      line-height: 45px;
      font-size: 14px;
      color: #999999;
      background-color: #fff;
      border: 1px solid #e5e5e5;
      border-radius: 3px;
      cursor: pointer;
      display:inline-block;
      width: 1198px;
      transition: 0.5s;
      margin-top: 20px;
      &:hover{
        color: #ed4040;
        border: 1px solid #ed4040;
      }
    }
  .tipBox{
    position: absolute;
    width: 27px;
    height: 70px;
    display: inline-block;
    top: 10px;
    left: 20px;
  }
    .tipBox img{
      width: 27px;
      height: 70px;
    }
  .tipBox span{
    position: absolute;
    width: 70px;
    height: 20px;
    top: 31px;
    left: -22px;
    font-size: 12px;
    color: #ffffff;
    transform: rotate(90deg);
  }
  .hovermsg{
    position: absolute;
    z-index: 3;
    width: 199px;
    height: 282px;
    border: 1px solid #ECECEC;
    top: 310px;
    left: 10px;
    background-color: #fff;
    text-align: center;
    transition: 1s;
  }
    .hovermsg .Btype{
      display: inline-block;
      width: 80px;
      text-align: center;
      border: 1px solid #ed4040;
      height: 18px;
      line-height: 18px;
      font-size: 14px;
      border-radius: 3px;
      color: #666;
      margin-top: 20px;
    }
    .hovermsg .hovermsg_div{
      padding-top: 30px;
      height: 36px;
      line-height: 36px;
      img{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        vertical-align: top;
      }
      span{
        font-size: 15px;
        color: #333;
        display: inline-block;
        height: 36px;
        line-height: 36px;
        vertical-align: top;
        margin-left: 10px;
      }
    }
    .hovermsg .showTime{
      margin-top: 10px;
      font-size: 13px;
      color: #333333;
    }
    .hovermsg  .hovermsg_btn{
      height: 40px;
      line-height: 40px;
      background-color: #E3013A;
      width: 120px;
      display: inline-block;
      margin-top: 20px;
      cursor: pointer;
      span{
        color: #ffffff;
        font-size: 16px;
        svg{
          font-size: 18px;
          margin-right: 5px;
        }
      }
      a{
        color: #ffffff;
        font-size: 16px;
      }
    }
    .showlist .lilist .hovermsg p{
    font-size: 16px;
    font-weight: 600;
    padding: 0 10px;
      padding-top: 20px;
    text-align: center;
    height: 40px;
    line-height: 20px;
      overflow: hidden;
      color: #333;
  }
    .lilist:hover >.hovermsg{
    top: 10px;
  }
</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .pushu_nav .gomaker{
      display: none;
    }
    .columnBoxInnner{
      width: 100%;
      overflow: hidden;
      padding-bottom: 20px;
      overflow-x: auto;
      .columnBoxInnnerList{
        white-space: nowrap;
        padding: 0 20px;
      }
    }
    .showlist{
      padding: 0 20px;
      width: auto;
      background-color: #fff;
      .lilist{
        display: block;
        width: 100%;
        box-shadow:none;
        margin-right: 0;
        border-bottom: 1px solid #eee;
        .imgBox{
          width: 30%;
          height: 100px;
          overflow: hidden;
          float: right;
          padding: 10px 0px;
          img{
            height: 100px;
            width: auto;
          }
        }
        .hovermsg{
          width: 70%;
          float: left;
          top: 0;
          height: 100px;
          border: none;
          p{
            padding: 0;
            margin: 0;
            font-size: 14px;
            padding-top: 10px;
            text-align: left;
          }
          .hovermsg_div{
            text-align: left;
          }
          .showTime{
            padding-bottom: 10px;
            margin-top: 8px;
            text-align: left;
          }
          .Btype{
            display: none;
          }
          .hovermsg_div{
            padding-top: 0;
            img{
              width: 30px;
              height: 30px;
              margin-top: 3px;
            }
          }
        }
      }
    }
    .addMore{
      width: 100%;
      margin-top: 0;
      margin-bottom: 40px;
    }
    .pushu_nav .bookTitle{
      margin-left: 0;
    }
  }
</style>
